import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Text } from '@chakra-ui/react'
import { FaTruck } from 'react-icons/fa'
import useStore from '../../../store'
import { colors } from '../../../utilities/colors'
import { Widget, WidgetHeader, WidgetBody } from '../../ui/Widget'
import QuoteRow from './QuoteRow'
import CarpoolSupportButton from '../CarpoolSupportButton'

export default function CarpoolQuotesPage() {
  const { t } = useTranslation()
  const { getDealerCarpoolQuotes, dealerQuotes, dealerQuotesFetching } = useStore()

  useEffect(() => {
    getDealerCarpoolQuotes()
  }, [])

  return (
    <>
      <Widget>
        <WidgetHeader
          title={t('All Transport Quotes')}
          showSpinner={dealerQuotesFetching}
          actionIcon={<CarpoolSupportButton />}
          overrideHeaderStyle={true}
        />
        <WidgetBody isVisible={!!dealerQuotes}>
          {!dealerQuotesFetching && dealerQuotes.length === 0 ? (
            <Box textAlign="center" p={8} color={colors.grey300}>
              <FaTruck size={32} style={{ margin: '0 auto 12px' }} />
              <Text fontSize="md">{t('No transport quotes yet')}</Text>
              <Text fontSize="sm" mt={1} color={colors.grey}>
                {t('Create a quote from the Units tab to get started')}
              </Text>
            </Box>
          ) : (
            dealerQuotes.map((quote) => (
              <QuoteRow key={quote.id} quote={quote} />
            ))
          )}
        </WidgetBody>
      </Widget>
    </>
  )
}
